const ROOT = '/tasks';

const routes = {
  tasks: () => ROOT,
  groupTasks: () => `${ROOT}?quick_filter=GROUP`,
  userTasks: () => `${ROOT}?quick_filter=MY`,
  allTasks: () => `${ROOT}?quick_filter=ALL`,
  item: (processId) => `/process/${processId}${ROOT}`
};

export default routes;
